<script setup lang="ts">
defineProps<{
  color?: any
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <g>
      <path
        d="M17.501,0C27.166,0,35,7.833,35,17.499C35,27.166,27.166,35,17.501,35C7.835,35,0,27.166,0,17.499
		C0,7.833,7.835,0,17.501,0"
      />
      <g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#FFFFFF"
          d="M6.921,25.76c-0.475,0-0.74,0-0.74,0
			c-0.486,0-0.881-0.392-0.881-0.879l0,0l0.004-15.46c0-0.488,0.391-0.882,0.876-0.882h0.74V25.76z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#FFFFFF"
          d="M14.481,8.787c0-1.632-1.321-2.953-2.952-2.953h-0.144
			c-1.63,0-2.953,1.322-2.953,2.953v17.426c0,1.631,1.323,2.953,2.953,2.953h0.144c1.631,0,2.952-1.322,2.952-2.953V8.787z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          fill="#FFFFFF"
          d="M15.978,8.541l12.843,0.001c0.485,0,0.878,0.391,0.878,0.879
			c0,7.034-0.003,15.46-0.003,15.46c0,0.487-0.39,0.881-0.875,0.881c-2.33,0-7.874,0-12.843-0.002V8.541z M18.698,10.267
			c-0.485,0-0.905,0.425-0.905,0.912v1.388c0,0.487,0.392,0.881,0.879,0.881h8.332c0.485,0,0.881-0.393,0.881-0.881v-1.418
			c0-0.487-0.369-0.882-0.852-0.882C27.033,10.267,20.923,10.267,18.698,10.267L18.698,10.267z M19.914,17.826
			c0-1.615,1.308-2.925,2.926-2.925c1.614,0,2.923,1.31,2.923,2.925v1.462l0,0v4.359h-5.849v-4.359V17.826 M23.577,20.733
			c0-0.409-0.329-0.74-0.737-0.74c-0.409,0-0.74,0.331-0.74,0.74c0,0.279,0.161,0.514,0.39,0.639v1.547h0.699v-1.547
			C23.417,21.246,23.577,21.012,23.577,20.733z M20.954,18.995h3.769v-1.17c0-1.042-0.847-1.891-1.889-1.891
			c-1.037,0-1.88,0.848-1.88,1.891V18.995z"
        />
      </g>
    </g>
  </svg>
</template>
